module.exports = require("crypto-js/sha1");